/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import USER_REPORT from '../BaseComponent/USERREPORT'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import Select from 'react-select'

class ReportSmsCrm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      DriversCount: 0,
      modalActivate: false,
      modalBlock: false,
      modalReset: false,
      modalChangeCar: false,
      cars: [],
      modalDelete: false,
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'receiveTime_desc',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'موبایل',
          value: 'mobile',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'متن پیام',
          value: 'content',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'زمان ارسال پیام',
          value: 'receiveTime',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'جزییات',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      report: [],
      editModal: false,
      receiveTimeMax: '',
      receiveTimeMin: '',
      senderId: '',
      printInfo: []
    }
  }

  getOperator = () => {
    return http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var operators = response.data.object
          for (let i = 0; i < operators.length; i++) {
            operators[i]['value'] = operators[i].personId
            operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
          }
          this.setState({
            operators: response.data.object
          })
          return response
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    let {receiveTimeMax, receiveTimeMin} = this.state
    filter.export = exportStatus
    let mobile = $('#mobile')
      .val()
      .trim()
    let contents = $('#contents')
      .val()
      .trim()
    let senderId = this.state.senderId === '' || this.state.senderId === null ? '' : this.state.senderId.personId
    if (mobile !== '') {
      filter.mobile = mobile
    }
    if (contents !== '') {
      filter.contents = contents
    }
    if (receiveTimeMin !== '') {
      filter.receiveTimeMin = receiveTimeMin
    }
    if (receiveTimeMax !== '') {
      filter.receiveTimeMax = receiveTimeMax
    }
    if (senderId !== '') {
      filter.senderId = senderId
    }
    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`crm/contact/sms/crm`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              report: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          message.error(response.data.description)
          this.setState({
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    this.getReport(false)
    this.getOperator()
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    this.setState(
      {
        pageNumber: 1
      },
      () => {
        this.getReport(false)
      }
    )
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    http
      .get(`crm/contact/sms/crm`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState(
            {
              excelReport: response.data.object.result
            },
            () => {
              this.state.excelReport.forEach((item) => {
                item.receiveTime = jMoment(item.receiveTime).format('jYYYY/jMM/jDD HH:mm')
              })
              this._export.save(this.state.excelReport)
            }
          )
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })
  }

  handleChangeFrom = (receiveTimeMin) => {
    this.setState({
      receiveTimeMin
    })
  }

  handleChangeTo = (receiveTimeMax) => {
    this.setState({
      receiveTimeMax
    })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  showDetail = (id) => {
    http
      .get(`/crm/contact/sms/crm/${id}`)
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            detailModal: true,
            customerMobile: res.data.object.result[0].mobile,
            customerContents: res.data.object.result[0].contents,
            sentTime: res.data.object.result[0].receiveTime
          })
        }
      })
      .catch((err) => {})
  }
  getValueOperator = (senderId) => {
    this.setState({
      senderId
    })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'موبایل', 'متن پیام', 'زمان ارسال پیام']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش sms های ارتباط با مشتریان"
              headerColSpan={4}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={1}
              rightColSpan={1}
              centerColSpan={2}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.mobile}</td>
                  <td>{item.contents}</td>
                  <td>{jMoment(item.receiveTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش sms های ارتباط با مشتریان.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'mobile'}
                field={'mobile'}
                title={'موبایل'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'contents'}
                field={'contents'}
                title={'متن پیام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'receiveTime'}
                field={'receiveTime'}
                title={'زمان ارسال پیام'}
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>ارتباط با مشتری</li>
            <li>گزارش sms های ارتباط با مشتریان</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={'send'} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>موبایل</label>
                  <input className="form-control" id="mobile" type="number" />
                </div>
                <div className="formComponent">
                  <label>متن پیام</label>
                  <textarea id="contents" className="form-control" />
                </div>
                <FromToPicker
                  onChangeFromDate={this.handleChangeFrom}
                  onChangeToDate={this.handleChangeTo}
                  fromLabel="زمان ارسال از"
                  toLabel="زمان ارسال تا"
                  defaulValue={false}
                  fromId="fromReg"
                  toId="toReg"
                />
                <div className="formComponent">
                  <label>کاربر ارسال کننده پیام</label>
                  <Select
                    value={this.state.senderId}
                    onChange={this.getValueOperator}
                    options={this.state.operators}
                    isClearable={true}
                    placeholder={''}
                  />
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            {this.state.report.length > 0 && (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  <tbody>
                    {this.state.report.map((item, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                        <td>{item.mobile}</td>
                        <td>
                          <span title={item.contents}>
                            {item.contents.length > 10 ? item.contents.substr(0, 10) + '...' : item.contents}
                          </span>
                        </td>
                        <td>{jMoment(item.receiveTime).format('jYYYY/jMM/jDD HH:mm')}</td>
                        <td>
                          <button onClick={() => this.showDetail(item.id)}>
                            <img src={require('../../image/eye.svg')} alt="" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumber}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.pageNumber}
                    total={this.state.countAll}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <Modal isOpen={this.state.detailModal} toggle={() => this.setState({detailModal: false})} size="sm">
          <ModalHeader toggle={() => this.setState({detailModal: false})}>جزییات</ModalHeader>
          <ModalBody>
            <p style={{fontSize: '1.3em'}}>
              <span className="text-dark font-weight-bold">دریافت کننده : </span>
              <span className="text-muted">{this.state.customerMobile}</span>
            </p>
            <p style={{fontSize: '1.3em'}}>
              <span className="text-dark font-weight-bold">متن کامل پیام : </span>
              <span className="text-muted">{this.state.customerContents}</span>
            </p>
            <p style={{fontSize: '1.3em'}}>
              <span className="text-dark font-weight-bold">زمان ارسال پیام : </span>
              <span className="text-muted">{jMoment(this.state.sentTime).format('jYYYY/jMM/jDD HH:mm')}</span>
            </p>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({detailModal: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default ReportSmsCrm
